// extracted by mini-css-extract-plugin
export default {"card":"BackgroundForm_card__4saPT","content":"BackgroundForm_content__KSrAo"};